<ion-grid>
  <ion-row class="ion-no-padding ion-align-items-center ion-justify-content-between" style="flex-wrap: nowrap;">
    <!-- <ion-col size="auto">
      <ion-button color="success" [disabled]="true" size="small" fill="clear">
        <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col> -->
  
    <ion-col size="auto">
      <ion-button (click)="likePhoto()" [disabled]="privateDisplay" size="small">
        <ion-icon name="caret-up-outline" slot="start"></ion-icon>
        Likes&nbsp;<span style="font-size: 12px;">{{ likes$ | async }}</span>
      </ion-button>
    </ion-col>
  
    <ion-col size="auto" *ngIf="privateDisplay">
      <ion-button color="danger" (click)="deletePhoto()" size="small" fill="clear">
        <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-img [src]=photoSrc (click)="photoClicked()"></ion-img>
  </ion-row>
</ion-grid>